import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React, { useContext } from "react";
import { HeaderComponent } from "../../../components/HeaderComponent/HeaderComponent";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { FooterComponent } from "../../../components/FooterComponent/FooterComponent";
import { HeaderSpacer } from "../../_layout-helpers/spacers";
import { ContentContainer } from "../../../components/_shared-components/arrangement/Container";
import { PageMetadataComponent } from "../../../components/PageMetadataComponent/PageMetadataComponent";

import { css } from "@emotion/react";

import { SwagSlugBuilder, type SwarovskiOptikShopLocale } from "@swo/shared";
import { CartPageData, ExtractSwarovskiPageData, type SwarovskiOptikShopLocaleFrontend } from "@swo/storefront";
import { ModalLoadingSpinner } from "../../../routes/modal-loading-spinner";
import { useStore } from "../../../store/hooks/use-store";
import { PageContext } from "../../../global/page-context";

const Lazy_CartComponent = React.lazy(() =>
  import("./CartComponent/CartComponent").then(m => ({ default: m.CartComponent })),
);

type CartPageDataT = ExtractSwarovskiPageData<CartPageData>;

export const CartPageLayout: ReactTFC<CartPageDataT> = props => {
  const linkToHomepage = SwagSlugBuilder.path(props.locale, props.segment, "");
  const { locationOrigin } = useStore().state;

  const {
    links: { myServiceRegister },
  } = useContext(PageContext);

  // This is going to be shop locale in cart page (and checkout)
  // but it's a bit tricky with the current setup to adjust types
  // hence this frontend-level mapping
  const shopLocale: SwarovskiOptikShopLocaleFrontend | null =
    props.locale.country === "INTERNATIONAL" ? null : { ...props.locale, country: props.locale.country };

  if (!shopLocale) {
    // this should never happen
    return null;
  }

  return (
    <>
      <PageMetadataComponent
        {...props.data.metadata}
        locationOrigin={locationOrigin}
        languageIsoCode={props.locale.language.isoCode}
        forceNoIndex={true}
      />

      <HeaderComponent header={props.data.header} version={"normal"} />
      <HeaderSpacer />
      <Spacer size={"md"} />

      <React.Suspense
        fallback={
          <ContentContainer
            className={"expand"}
            attachStyles={css`
              min-height: 60vh;
            `}
          >
            <ModalLoadingSpinner />
          </ContentContainer>
        }
      >
        <ContentContainer
          className={"expand"}
          attachStyles={css`
            // provide some white background while cart state is being resolved
            // this prevents footer from jumping heavily
            min-height: 60vh;
          `}
        >
          <Lazy_CartComponent
            contactData={props.data.contactData}
            translations={props.data.cartTranslations}
            checkoutTranslations={props.data.checkoutTranslations}
            generalTranslations={props.generalTranslations}
            deliveryOptions={props.data.deliveryOptions}
            linkToCheckout={props.data.linkToCheckout}
            linkToHomepage={linkToHomepage}
            locale={shopLocale}
            segment={props.segment}
            linkToMyServiceRegister={myServiceRegister}
            deliveryDaysRange={props.data.deliveryDaysRange}
            purchaseConfirmationPagePath={"/" /* FIXME */}
          />

          <Spacer size={"md"} />
        </ContentContainer>
        <FooterComponent {...props.data.footer} />
      </React.Suspense>
    </>
  );
};
